<template>
	<div>
		<el-page-header @back="goBack" content="维护测评题目"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>

				<div style="margin-top: 30px">
					<el-button type="primary" plain @click="handelResultSet"
						>结果设置
					</el-button>
					<el-button type="danger" plain @click="delQuestionBank"
						>删除所有题目
					</el-button>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div>
					<span>一级维度：</span>
					<span>
						<el-tag
							class="tag-marr"
							:key="index"
							closable
							:class="{ activeBg: dimensionInfoId == item.examDimensionId }"
							@close="deleteDimension(item.code, 'wd')"
							effect="plain"
							@click="activeEvent(item, 'wd')"
							v-for="(item, index) in dimensionList"
							>{{ item.name }}</el-tag
						>
						<el-tag
							class="tag-marr"
							effect="plain"
							@click="handleIncreaseDimension('wd')"
							><i class="el-icon-plus"></i
						></el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							@click="handleDimensionEdit('wd')"
							><i class="el-icon-edit"></i
						></el-tag>
					</span>
				</div>
				<div class="marr">
					<span>二级维度：</span>
					<span>
						<el-tag
							effect="plain"
							class="tag-marr"
							closable
							:class="{ activeBg1: datumId == item.code }"
							@close="deleteDimension(item.code, 'jz')"
							@click="activeEvent(item, 'jz')"
							:key="index"
							v-for="(item, index) in datumList"
							type="danger"
							>{{ item.name }}</el-tag
						>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="danger"
							@click="handleIncreaseDimension('jz')"
							><i class="el-icon-plus"></i
						></el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="danger"
							@click="handleDimensionEdit('jz')"
							><i class="el-icon-edit"></i
						></el-tag>
					</span>
				</div>
				<div class="marr">
					<span>测评题目：</span>
					<el-button
						type="success"
						size="small"
						@click="handleSubjectIncrease('add')"
						>添加 <i class="el-icon-plus"></i
					></el-button>
				</div>
				<div style="margin-top: 20px">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="tableData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="examDimensionVo"
								label="一级维度"
								width="120"
								align="center"
							>
								<template slot-scope="scope">
									{{ emptyShow(scope.row.examDimensionVo).name }}
								</template>
							</el-table-column>
							<el-table-column
								prop="examDimensionVo"
								label="二级维度"
								width="120"
								align="center"
							>
								<template slot-scope="scope">
									{{ emptyShow(scope.row.examDatumVo).name }}
								</template>
							</el-table-column>
							<el-table-column
								prop="name"
								label="题目"
								min-width="300"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="viewName"
								label="布局"
								width="100"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="answers"
								label="答案"
								width="80"
								align="center"
							>
							</el-table-column>

							<el-table-column
								prop="payPrice"
								label="分数"
								width="120"
								align="center"
							>
								<template slot-scope="scope">
									{{ scope.row.minScore }}~{{ scope.row.maxScore }}
								</template>
							</el-table-column>

							<el-table-column
								prop="seq"
								label="排序"
								width="100"
								align="center"
							>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="220"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleSubjectIncrease('edit', scope.row)"
										type="success"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleSubjectIncrease('answer', scope.row)"
										type="warning"
										plain
										>答案
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 添加维度/基准弹框 -->
		<el-dialog
			:title="clickType == 'jz' ? '添加/编辑二级维度' : '添加/编辑一级维度'"
			:visible.sync="dialogVisible"
			width="460px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('dimension')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="一级维度" v-if="clickType == 'jz'">
						{{ dimensionInfo.name }}
					</el-form-item>
					<el-form-item label="ICON">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
									v-if="params.icon"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="!params.icon"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>

					<el-form-item label="名称" prop="name">
						<el-input placeholder="请填写名称" v-model="params.name"></el-input>
					</el-form-item>

					<el-form-item prop="code" label="标识">
						<el-input placeholder="请填写标识" v-model="params.code"></el-input>
					</el-form-item>

					<el-form-item
						label="计分方式"
						prop="scoreType"
						v-if="clickType == 'jz'"
					>
						<el-radio v-model="params.scoreType" :label="0">计入总分</el-radio>
						<el-radio v-model="params.scoreType" :label="1">平均分</el-radio>
					</el-form-item>
					<el-form-item label="说明" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入说明"
							v-model="params.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item prop="seq" label="序号">
						<el-input placeholder="请填写序号" v-model="params.seq"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 添加 编辑 题目弹框 -->
		<el-dialog
			title="添加/编辑题目"
			:visible.sync="dialogVisibleTopic"
			width="460px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleFormTopic"
					:rules="rulesTopic"
					:model="topicParams"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="一级维度">
						{{ dimensionInfo.name }} 【 {{ dimensionInfo.code }} 】
					</el-form-item>
					<template v-if="clickType == 'add'">
						<el-form-item label="二级维度" v-if="datumInfo.name != '全部'">
							{{ datumInfo.name }} 【 {{ datumInfo.code }} 】
						</el-form-item>
					</template>
					<template v-if="clickType == 'edit'">
						<el-form-item label="二级维度" v-if="topicParams.examDatumVo">
							{{ topicParams.examDatumVo.name }} 【
							{{ topicParams.examDatumVo.code }} 】
						</el-form-item>
					</template>
					<el-form-item label="布局" prop="view">
						<el-select
							v-model="topicParams.view"
							clearable
							placeholder="请选择布局"
							style="width: 100%"
						>
							<el-option label="方式一(列表)" value="ve1"></el-option>
							<el-option label="方式二(四维)" value="ve2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy(index)"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="isMoer"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>
					<el-form-item prop="name" label="题目">
						<el-input
							placeholder="请填写题目"
							v-model="topicParams.name"
						></el-input>
					</el-form-item>
					<el-form-item prop="subtitle" label="副标题">
						<el-input
							placeholder="请填写副标题"
							v-model="topicParams.subtitle"
						></el-input>
					</el-form-item>
					<el-form-item label="解析" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请填写解析"
							v-model="topicParams.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item prop="tx" label="排序">
						<el-input
							type="number"
							placeholder="请填写排序"
							v-model="topicParams.seq"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleTopic = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEditTopic"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 添加答案弹框 -->
		<el-dialog
			title="添加答案"
			:visible.sync="dialogVisibleAnswer"
			width="700px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<el-tabs
				type="card"
				v-model="languageCode"
				@tab-click="handleTabClick('answer')"
			>
				<el-tab-pane
					v-for="(item, index) in languageList"
					:label="item.name"
					:name="item.code"
					:key="index"
				></el-tab-pane>
			</el-tabs>
			<div style="margin-bottom: 10px">
				<span>题目：{{ topicParams.name }}</span>
				<div v-if="topicParams.icon">
					<img
						:src="topicParams.icon"
						style="width: 100px; height: 100px; object-fit: contain"
					/>
				</div>
			</div>
			<div style="margin-bottom: 10px">
				<span>答题方式：</span>
				<span>{{ topicParams.answerWayName }}</span>
			</div>
			<div style="margin-bottom: 10px">
				<span>布局方式：</span>
				<span>{{ topicParams.viewName }}</span>
			</div>
			<div class="public-table-data">
				<el-table
					ref="multipleTable"
					size="mini"
					:data="answerTableData"
					border
					style="width: 100%"
					row-key="menuId"
					v-loading="loading"
				>
					<el-table-column type="index" label="序号" width="80" align="center">
					</el-table-column>
					<el-table-column prop="icon" label="图标" width="120" align="center">
						<template slot-scope="scope">
							<div class="diplay" @click="answerChangIndex(scope.$index)">
								<div class="screenshot">
									<span class="slideshow">
										<el-image
											v-if="scope.row.icon"
											style="width: 40px; height: 40px; border-radius: 6px"
											:src="scope.row.icon"
											fit="cover"
											@click="getPolicyAnswer"
										/>
									</span>
									<div
										class="up-btn"
										style="width: 40px; height: 40px; line-height: 45px"
										@click="getPolicyAnswer"
										v-if="!scope.row.icon"
									>
										<i class="el-icon-plus"></i>
									</div>
								</div>
								<input
									type="file"
									ref="fileAnswer"
									id="uploadFile"
									@change="getFileAnswer()"
									accept="image/png,image/jpg"
								/>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="答案" width="200" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.name"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="score" label="分值" width="80" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.score"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="seq" label="排序" width="80" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.seq"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button
								size="mini"
								@click="handleAnswerDelete(scope.row, scope.$index)"
								type="danger"
								plain
								>删除</el-button
							>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleAnswer = false"
					>取 消</el-button
				>
				<el-button size="medium" type="success" @click="handleAddAnswer"
					>添加答案</el-button
				>
				<el-button size="medium" type="primary" @click="submitAnswer"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { ossUpload } from "@utils/filters/upload";
import { emptyShow, isEmpty } from "@utils/tools";

export default {
	name: "mjywlList",
	data() {
		return {
			emptyShow,
			isEmpty,
			loading: false,
			detalisObj: {},
			dimensionList: [],
			dialogVisible: false,
			rules: {
				name: [{ required: true, message: "请填写名称", trigger: "change" }],
				code: [{ required: true, message: "请填写标识", trigger: "change" }],
				seq: [{ required: true, message: "请填写标识", trigger: "change" }],
			},
			params: {},
			srcList: [],
			isMoer: true,
			dimensionInfoId: "",
			dimensionInfo: {},
			// clickType: '',
			datumList: [],
			datumId: "",
			datumInfo: {},
			tableData: [],
			dialogVisibleTopic: false,
			topicParams: {},
			rulesTopic: {
				view: [{ required: true, message: "请选择布局", trigger: "change" }],
				name: [{ required: true, message: "请填写题目", trigger: "change" }],
			},
			clickType: "",
			dialogVisibleAnswer: false,
			answerParams: {},
			answerTableData: [],
			answerDataIndex: "",
			srcListAnswer: [],
			isMoerAnswer: true,
			languageList: [],
			languageCode: "",
		};
	},
	mounted() {
		this.getAppraisalData(true);
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question") {
				this.srcList = [];
				this.isMoer = false;
				if (this.topicParams.questionId) {
					this.getSubjectInfo(this.topicParams.questionId);
				} else {
					this.isMoer = true;
				}
			} else if (e == "answer") {
				this.getAnswerList(this.topicParams.questionId);
			} else if (e == "dimension") {
				this.handleDimensionEdit(this.clickType);
			}
		},
		async getQuestionContentInfo() {
			const { data: resData } = await this.$get(
				`exam/question/info/${this.topicParams.questionId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			this.topicParams = resData.data;
			this.isMoer = false;
			this.$nextTick(() => {
				this.isMoer = true;
			});
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData(e) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			if (e) {
				this.getDimensionList();
			}
		},
		/**
		 * 获取基准列表
		 */
		async getJZList() {
			this.datumList = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/datum/list`, {
				params: {
					examId: this.$route.query.examId,
					examDimensionCode: this.dimensionInfo.code,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;

			if (resData.data) {
				this.datumList = resData.data;
				let obj = {
					name: "全部",
					code: this.dimensionInfo.code + "1",
				};
				this.datumList.unshift(obj);
				this.datumId = this.dimensionInfo.code + "1";
				this.datumInfo = this.datumList[0];
				this.getSubjectList();
			} else {
				this.datumList = [
					{
						name: "全部",
						code: this.dimensionInfo.code + "1",
					},
				];
				this.datumId = this.dimensionInfo.code + "1";
				this.datumInfo = this.datumList[0];
				this.getSubjectList();
			}
		},
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.dimensionList = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.dimensionList = resData.data;
				if (!this.dimensionInfoId) {
					this.dimensionInfoId = resData.data[0].examDimensionId;
					this.dimensionInfo = resData.data[0];
					this.getJZList();
				}
			}
		},
		/**
		 * 维度切换
		 */
		activeEvent(item, e) {
			if (e == "wd") {
				this.dimensionInfoId = item.examDimensionId;
				this.dimensionInfo = item;
				this.getJZList();
			} else {
				this.datumId = item.code;
				this.datumInfo = item;
				this.getSubjectList();
			}
		},
		/**
		 * 删除维度
		 */
		deleteDimension(code, e) {
			this.$confirm("此操作将永久删除当前数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				if (e == "wd") {
					const { data: resData } = await this.$delete(
						`exam/dimension/info/${this.$route.query.examId}/${code}`,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.getDimensionList();
					this.$message.success("删除成功!");
				} else {
					const { data: resData } = await this.$delete(
						`exam/datum/info/${this.$route.query.examId}/${code}`,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.getJZList();
					this.$message.success("删除成功!");
				}
			});
		},
		/**
		 * 编辑维度/基准
		 */
		async handleDimensionEdit(e) {
			this.clickType = e;
			if (e == "wd") {
				this.loading = true;
				const { data: resData } = await this.$get(
					`exam/dimension/info/${this.$route.query.examId}/${this.dimensionInfo.code}`,
					{
						headers: {
							"Language-Code": this.languageCode,
						},
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				this.params = resData.data;
				this.srcList = [];
				if (resData.data.icon) {
					this.params.icon = resData.data.icon;
					this.srcList.push(resData.data.icon);
				}
				this.dialogVisible = true;
			} else if (e == "jz") {
				if (this.datumInfo.name == "全部") {
					this.$message.warning("全部无法编辑");
					return;
				}
				this.loading = true;
				const { data: resData } = await this.$get(
					`exam/datum/info/${this.$route.query.examId}/${this.datumInfo.code}`,
					{
						headers: {
							"Language-Code": this.languageCode,
						},
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				this.params = resData.data;
				this.srcList = [];
				if (resData.data.icon) {
					this.params.icon = resData.data.icon;
					this.srcList.push(resData.data.icon);
				}
				this.dialogVisible = true;
			}
		},
		/**
		 * 添加维度/基准
		 */
		handleIncreaseDimension(e) {
			this.clickType = e;
			this.dialogVisible = true;
			this.isMoer = true;
			this.params = {};
			this.srcList = [];
		},
		/**
		 * 维度/基准数据保存
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					if (this.clickType == "wd") {
						this.params.examId = this.$route.query.examId;
						const { data: resData } = await this.$post(
							"exam/dimension/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						// this.dialogVisible = false;
						this.$message.success("操作成功!");
						this.getDimensionList();
						this.handleDimensionEdit(this.clickType);
						this.params = {};
						this.srcList = [];
					} else if ((this.clickType = "jz")) {
						this.params.examId = this.$route.query.examId;
						this.params.examDimensionCode = this.dimensionInfo.code;
						const { data: resData } = await this.$post(
							"exam/datum/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						// this.dialogVisible = false;
						this.$message.success("操作成功!");
						// this.getJZList();
						this.handleDimensionEdit(this.clickType);
						this.params = {};
						this.srcList = [];
					}
				});
			});
		},
		/**
		 * 获取题目列表
		 */
		async getSubjectList() {
			this.loading = true;
			let temp = {};
			if (this.datumInfo.name != "全部") {
				temp = {
					examId: this.$route.query.examId,
					examDimensionCode: this.dimensionInfo.code,
					examDatumCode: this.datumInfo.code,
				};
			} else {
				temp = {
					examId: this.$route.query.examId,
					examDimensionCode: this.dimensionInfo.code,
				};
			}
			const { data: resData } = await this.$get(`exam/question/list`, {
				params: temp,
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (emptyShow(resData.data)) {
				this.tableData = resData.data;
			} else {
				this.tableData = [];
			}
		},
		/**
		 * 测评题目添加/编辑相关
		 */
		handleSubjectIncrease(type, data) {
			this.clickType = type;
			if (type == "add") {
				this.isMoer = true;
				this.topicParams = {};
				this.srcList = [];
				this.dialogVisibleTopic = true;
			} else if (type == "edit") {
				this.getSubjectInfo(data.questionId);
				this.dialogVisibleTopic = true;
			} else if (type == "answer") {
				this.getSubjectInfo(data.questionId);
				this.getAnswerList(data.questionId);
				this.dialogVisibleAnswer = true;
			}
		},
		/**
		 * 测评题目删除
		 */
		async handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/question/info/${row.questionId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getAppraisalData(false); //刷新总题目
				this.getSubjectList();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 测评题目数据提交
		 */
		handleEditTopic() {
			this.$refs.ruleFormTopic.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.topicParams.examId = this.$route.query.examId;
					if (this.clickType == "add") {
						this.topicParams.examDimensionCode = this.dimensionInfo.code;
						this.topicParams.answerWay = "sel1";
						if (this.datumInfo.name != "全部") {
							this.topicParams.examDatumCode = this.datumInfo.code;
						}
						const { data: resData } = await this.$post(
							"exam/question/info",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.dialogVisibleTopic = false;
						this.$message.success("添加成功!");
					} else if (this.clickType == "edit") {
						const { data: resData } = await this.$put(
							"exam/question/info",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.dialogVisibleTopic = false;
						this.$message.success("修改成功!");
					}
					this.getAppraisalData(false); //刷新总题目
					this.getSubjectList();
				});
			});
		},
		/**
		 * 测评题目详情
		 */
		async getSubjectInfo(questionId) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/exam/question/info/${questionId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.topicParams = resData.data;
			this.srcList = [];
			if (resData.data.icon) {
				this.topicParams.icon = resData.data.icon;
				this.srcList.push(resData.data.icon);
			}
		},
		/** 答案 start */
		// 获取答案的数据列表
		async getAnswerList(questionId) {
			this.answerTableData = [];
			const { data: resData } = await this.$get(`exam/answer/list`, {
				params: {
					questionId,
				},
				headers: {
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) return;
			if (resData.data) {
				this.answerTableData = resData.data;
			} else {
				this.answerTableData = [];
			}
		},
		// 添加答案数据列表
		handleAddAnswer() {
			this.answerTableData.push({
				icon: "",
				name: "",
				score: "",
				seq: "",
				answerId: this.answerTableData.length,
			});
		},
		//提交答案
		submitAnswer() {
			this.$confirm("确认保存数据, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const { data: resData } = await this.$post(
					"exam/answer/list",
					{
						answers: this.answerTableData,
						questionId: this.topicParams.questionId,
					},
					{
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("添加成功!");
				this.getSubjectList();
				// this.dialogVisibleAnswer = false;
			});
		},
		//答案删除
		handleAnswerDelete(row, index) {
			if (!row.examAnswerId) {
				this.answerTableData.splice(index, 1);
			} else {
				this.$confirm("此操作将删除答案数据, 是否继续?", "提示", {
					type: "warning",
				}).then(async () => {
					const { data: resData } = await this.$delete(
						`exam/answer/info/${row.answerId}`,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.getSubjectList();
					this.getAnswerList(this.topicParams.questionId);
					this.$message.success("删除成功!");
				});
			}
		},
		//答案图片设置相关
		getPolicyAnswer() {
			this.$refs.fileAnswer.dispatchEvent(new MouseEvent("click"));
		},
		async getFileAnswer() {
			const that = this;
			const { data: resData } = await this.$get("aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.fileAnswer.files[0],
				resData.data,
				"one", //'more','one'
				this.srcListAnswer
			);
			this.isMoerAnswer = false;
			this.srcListAnswer = addRoutes;
			this.answerTableData[this.answerDataIndex].icon = this.srcListAnswer[0];
		},
		answerChangIndex(val) {
			this.answerDataIndex = val;
		},

		handelResultSet() {
			this.$router.push({
				name: "MJYWL_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		delQuestionBank() {
			this.$confirm("此操作将永久删除该测评题库数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/question/list/${this.$route.query.examId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getExamInfo();
				this.$message.success("删除成功!");
			});
		},
		goBack() {
			this.$router.back();
		},
		/**
		 * 图片上传
		 */
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("aliyun/oss/sign", {
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});

			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			this.isMoer = false;
			this.srcList = addRoutes;
			this.params.icon = this.srcList[0];
			this.topicParams.icon = this.srcList[0];
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}
.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}
</style>
